import { render, staticRenderFns } from "./UpcomingBattlesPagination.vue?vue&type=template&id=7c63b32e&scoped=true&"
import script from "./UpcomingBattlesPagination.vue?vue&type=script&lang=ts&"
export * from "./UpcomingBattlesPagination.vue?vue&type=script&lang=ts&"
import style0 from "./UpcomingBattlesPagination.vue?vue&type=style&index=0&id=7c63b32e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c63b32e",
  null
  
)

export default component.exports